import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { listPublishedCourses } from "@/lib/academy.functions";
import { CourseCard } from "@/components/academy/CourseCard";

export const Route = createFileRoute("/aluno/cursos")({
  ssr: false,
  component: CursosPage,
});

function CursosPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["academy", "courses"],
    queryFn: () => listPublishedCourses(),
    staleTime: 60_000,
  });
  return (
    <div className="space-y-6">
      <div>
        <span className="inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-primary">
          Catálogo completo
        </span>
        <h1 className="mt-3 text-3xl font-extrabold tracking-tight md:text-4xl">Todos os módulos</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Acesso liberado a todo conteúdo premium da Academia SVG.
        </p>
      </div>
      {isLoading ? (
        <p className="text-sm text-muted-foreground">Carregando…</p>
      ) : !data || data.length === 0 ? (
        <div className="rounded-2xl border border-ink/10 shadow-[var(--shadow-soft)] bg-ink/[0.045] p-8 text-center text-sm text-muted-foreground">
          Nenhum curso publicado ainda.
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {data.map((c: any, i: number) => (
            <CourseCard
              key={c.id}
              slug={c.slug}
              title={c.title}
              cover_url={c.cover_url}
              category={c.category}
              level={c.level}
              index={i + 1}
            />
          ))}
        </div>
      )}
    </div>
  );
}